import React, { useEffect, useState } from "react";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "../ui/switch";
import { adminReminders } from "../../services/adminApi";

export const RefillReminderToggle = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    adminReminders.get().then(setSettings);
  }, []);

  const toggle = async (enabled) => {
    setSettings((s) => ({ ...s, enabled }));
    try {
      await adminReminders.setEnabled(enabled);
      toast.success(enabled ? "Recordatorios activados" : "Recordatorios apagados");
    } catch {
      setSettings((s) => ({ ...s, enabled: !enabled }));
      toast.error("No se pudo guardar el cambio");
    }
  };

  if (!settings) return null;

  return (
    <div
      className="mt-6 bg-white border border-stone-200 rounded-2xl p-6 flex items-start sm:items-center justify-between gap-4"
      data-testid="refill-reminder-card"
    >
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 bg-emerald-50 rounded-xl flex items-center justify-center flex-shrink-0">
          <BellRing className="w-5 h-5 text-emerald-700" />
        </div>
        <div>
          <p className="font-semibold text-stone-800">Recordatorio de recarga</p>
          <p className="text-sm text-stone-500">
            Correo automático a cada clienta {settings.weeks} semanas después de su compra invitándola a comprar su refill.
          </p>
          <p className="text-xs text-stone-400 mt-1" data-testid="refill-reminder-sent-count">
            Recordatorios enviados: {settings.sent_count}
          </p>
        </div>
      </div>
      <Switch
        checked={settings.enabled}
        onCheckedChange={toggle}
        data-testid="refill-reminder-switch"
      />
    </div>
  );
};
